import { render } from "./CodigoEnviado.vue?vue&type=template&id=7c6e8259"
import script from "./CodigoEnviado.vue?vue&type=script&lang=js"
export * from "./CodigoEnviado.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__